import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { pick } from "nodash"
import { PanelModes, PanelNames } from "panels/constants"
import { PanelModeMap, PanelsState, SetPanelModePayload } from "./types"
import { initialState } from "./constants"
import {
    restoredFromSuspenseMemoryAction,
    setPanelModeAction,
    suspendedVisibilityAction,
} from "./actions"
import {
    activatedOverlayAction,
    hiddenOverlayAction,
    resetOverlayAction,
} from "features/content-overlay/slice"

export const panelsSlice = createSlice({
    name: "panels",
    initialState,
    reducers: {
        switchedWallboardToHiddenMode: (state) => {
            state.mode[PanelNames.Wallboard] = PanelModes.Hidden
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                setPanelModeAction,
                (state: PanelsState, action: PayloadAction<SetPanelModePayload>) => {
                    const { payload } = action
                    const { panel, mode } = payload

                    state.mode[panel] = mode
                }
            )
            .addCase(
                suspendedVisibilityAction,
                (state: PanelsState, action: PayloadAction<PanelNames[]>) => {
                    const targets = action.payload

                    state.suspenseMemory = pick(state.mode, targets)

                    const suspendedModes = Object.fromEntries(
                        targets.map((n) => [n, PanelModes.Hidden])
                    ) as PanelModeMap

                    state.mode = {
                        ...state.mode,
                        ...suspendedModes,
                    }
                }
            )
            .addCase(restoredFromSuspenseMemoryAction, (state: PanelsState) => {
                const originalModes = state.suspenseMemory || {}

                state.mode = {
                    ...state.mode,
                    ...originalModes,
                }

                state.suspenseMemory = undefined
            })
            .addCase(hiddenOverlayAction, (state) => {
                state.mode.overlay = PanelModes.Hidden
            })
            .addCase(resetOverlayAction, (state) => {
                state.mode.overlay = PanelModes.Hidden
            })
            .addCase(activatedOverlayAction, (state) => {
                state.mode.overlay = PanelModes.Regular
            })
    },
})

const { reducer } = panelsSlice

export default reducer
